
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delhi",
      function () {
        return require("private-next-pages/delhi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delhi"])
      });
    }
  